"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CoreInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var suffix = props.suffix,
      addonAfter = props.addonAfter,
      search = props.search,
      className = props.className,
      prefix = props.prefix,
      addonAfterBorder = props.addonAfterBorder,
      restProps = _objectWithoutProperties(props, ["suffix", "addonAfter", "search", "className", "prefix", "addonAfterBorder"]);

  var classNameAddonAfter = (0, _utils.getClassNames)('TextInput-group-addon', {
    'addon-after-border': addonAfterBorder
  });
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(className, " TextInput-group-wrapper")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "TextInput-wrapper TextInput-group"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: " TextInput-affix-wrapper"
  }, prefix && /*#__PURE__*/_react.default.createElement("span", {
    className: "TextInput-prefix"
  }, prefix), /*#__PURE__*/_react.default.createElement("input", _extends({}, restProps, {
    className: "TextInput",
    ref: ref
  })), suffix && /*#__PURE__*/_react.default.createElement("span", {
    className: "TextInput-suffix"
  }, suffix)), addonAfter && /*#__PURE__*/_react.default.createElement("span", {
    className: classNameAddonAfter
  }, addonAfter)));
});
CoreInput.propTypes = {
  /** The prefix icon for the input. */
  prefix: _propTypes.default.node,

  /** The suffix icon for the input. */
  suffix: _propTypes.default.node,

  /** @ignore */
  addonAfter: _propTypes.default.string,

  /** Whether the input is search field */
  search: _propTypes.default.bool,

  /** @ignore */
  className: _propTypes.default.string,
  // ** Show suffix border */
  addonAfterBorder: _propTypes.default.bool
};
CoreInput.defaultProps = {
  prefix: null,
  suffix: null,
  addonAfter: null,
  search: false,
  className: false,
  addonAfterBorder: true
};
var _default = CoreInput;
exports.default = _default;